import type { GetReview200AllOfTwoInstructorResponse } from './getReview200AllOfTwoInstructorResponse';
import type { GetReview200AllOfTwoUserVote } from './getReview200AllOfTwoUserVote';

export type GetReview200AllOfTwo = {
  /** 강사 응답 */
  instructorResponse?: GetReview200AllOfTwoInstructorResponse;
  /** 현재 사용자의 투표 상태 */
  userVote?: GetReview200AllOfTwoUserVote;
};
